export default function buildSubscriber() {
    let currentListeners = [];
    let nextListeners = currentListeners;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = currentListeners.slice();
        }
    }

    return {
        subscribe(callback) {
            ensureCanMutateNextListeners();
            nextListeners.push(callback);
            const unsubscribe = () => {
                const index = nextListeners.indexOf(callback);
                ensureCanMutateNextListeners();
                nextListeners.splice(index, 1);
            };

            return unsubscribe;
        },
        emit(...args) {
            // This protects against a listener unsubscribing while we're
            // looping through the listeners. I got this pattern from Redux
            // https://github.com/reactjs/redux/blob/e872b483c291f45a0dae18b90d5a7d615c503af2/src/createStore.js#L174-L177
            currentListeners = nextListeners;
            for (let i = 0; i < currentListeners.length; i++) {
                currentListeners[i](...args);
            }
        },
    };
}



// WEBPACK FOOTER //
// ./src/build_subscriber.js